<template>
    <button @click="start(500)">500*500</button>
    <button @click="start(250)">250*250</button>
    <button @click="start(150)">150*150</button>
    <div id="reader" width="600px"></div>

    <div>
        <div v-for="item in devicesList" :key="item.id">
            {{ item }}
        </div>
        <div>
            错误信息：{{ error }}
        </div>
        <button @click="start(0)">开始</button>
        <button @click="stop">停止</button>
        
    </div>
  </template>

<script>
import { onMounted,onUnmounted,ref } from 'vue';
import { Html5Qrcode } from 'html5-qrcode';



export default ({
    
    setup() {
        const error=ref("");
        const devicesList=ref([]);
        let html5QrCode ;
        onMounted(() => {
            html5QrCode= new Html5Qrcode("reader");
        });
        onUnmounted(() => {
            stop();
        });
        
        const  start=(size) =>{
            if(size>0){
                localStorage.setItem("size",size);
            }else{
                var cacheSize=localStorage.getItem("size");
                if(cacheSize){
                    size=parseInt(cacheSize);
                }else{
                    size=250;
                }
            }
            html5QrCode.start({ facingMode: "environment" }, { fps: 60, qrbox: { width: size, height: size } }, (decodedText)=>{
                alert(decodedText);
            });
        }
        const stop=()=> {
            html5QrCode
            .stop()
            .then((ignore) => {
            // QR Code scanning is stopped.
                alert("停止成功");
                console.log(ignore);
            })
            .catch((err) => {
                alert("stoperr"+err);
                // Stop failed, handle it.
                console.log(err);
            });
        }

        return{
            error,
            devicesList,
            stop,
            start,
        }
        
    },
})
</script>
